const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api`;
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');
export const STOREFRONT_ORIGIN = process.env.REACT_APP_STOREFRONT_URL || 'https://zobox.in';

/**
 * Robust media URL resolver for all CMS previews and components.
 * Handles:
 * - full URLs (http/https/data:): returns as-is
 * - local uploads (/uploads/...): prepends backend API_ORIGIN
 * - storefront assets (/assets/...): returns path or absolute URL
 */
export function resolveMediaUrl(value = '') {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  // Already absolute or data URL
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  // Backend uploaded media (/uploads/...)
  if (trimmed.startsWith('/uploads/')) {
    return `${API_ORIGIN}${trimmed}`;
  }

  return trimmed;
}

/**
 * Graceful image onError handler that tries fallback sources before showing a placeholder
 */
export function handleImageError(event, fallbackUrl) {
  const target = event.currentTarget || event.target;
  if (!target) return;

  const currentSrc = target.src || '';

  // If already tried fallback, prevent infinite loops
  if (target.dataset.hasFailedTwice) {
    target.style.display = 'none';
    return;
  }

  // First fallback: if relative /assets/ failed on localhost, try live storefront
  if (currentSrc.includes('/assets/') && !currentSrc.startsWith('https://zobox.in') && !currentSrc.startsWith('https://newweb.zobox.in')) {
    target.dataset.hasFailedOnce = 'true';
    const assetPath = currentSrc.substring(currentSrc.indexOf('/assets/'));
    target.src = `https://zobox.in${assetPath}`;
    return;
  }

  // Second fallback: if user provided fallback
  if (fallbackUrl && currentSrc !== fallbackUrl) {
    target.dataset.hasFailedTwice = 'true';
    target.src = fallbackUrl;
    return;
  }

  target.dataset.hasFailedTwice = 'true';
  target.style.display = 'none';
}
